module.exports = __webpack_public_path__ + "static/img/5.9db3532.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/5.svg
// module id = 700
// module chunks = 1